// extracted by mini-css-extract-plugin
module.exports = {"swipe":"swipe--1lAql"};